export default{
    addReferral: 'ثبت مراجعه',
    editReferral: 'ویرایش مراجعه',
    dateTimeReferral: 'تاریخ و ساعت مراجعه',
    doctor: 'پزشک معالج',
    unit:'واحد',
    receptionType: 'علت مراجعه',
    room: 'اتاق',
    insurance: 'بیمه',
    postReferrals: 'مراجعات پیشین',
    description: 'توضیحات',
    diagnosis: 'تشخیص',
    emergency:'اورژانسی',
    recallNumber:'شماره فراخوانی',
    service:'خدمات دریافتی',
    callingNumber: 'شماره فراخوانی'
}
